import { Divider } from 'components/Divider';
import { theme } from 'configs/styled';
import React from 'react';
import TextBold from './TextBold';
import TextRegular from './TextRegular';

interface IMessageDisplayProps {
  title: string;
  fontSize?: string;
}

const MessageDisplay: React.FC<IMessageDisplayProps> = props => {
  const { title, children, fontSize = theme.fontSize.md } = props;
  return (
    <>
      <TextBold
        fontSize={fontSize}
        color={theme.palettes.black85}
        margin={'0px 0px 8px'}
        display={'block'}
      >
        {title}
      </TextBold>
      <TextRegular
        color={theme.palettes.black85}
        margin={'0px 0px 8px'}
        display={'block'}
      >
        {children}
      </TextRegular>
      <Divider />
    </>
  );
};

export default MessageDisplay;
